import { Link } from 'react-router-dom';
const HeaqderNav =()=>{
    return <ul className="header-nav">
        <li><Link to={`/user-info/`}>会員情報</Link></li>
        <li><Link to={`/payment/`}>お支払い</Link></li>
    </ul>
}
export default HeaqderNav;
